
export default function WhyChooseSection() {
  const reasons = [
    {
      id: 'local',
      title: '地域密着',
      description: '長年培ってきた地域との深いつながりで、エリアの特性を熟知した最適なご提案をいたします。',
      icon: 'ri-map-pin-line',
      stats: '設立25年'
    },
    {
      id: 'experience',
      title: '豊富な実績',
      description: '累計5,000件以上の取引実績と経験豊富なスタッフが、安心・安全な取引をサポートします。',
      icon: 'ri-trophy-line',
      stats: '取引実績5,000件+'
    },
    {
      id: 'support',
      title: 'アフターサポート',
      description: '契約後もお客様との関係を大切にし、住まいに関するあらゆるご相談に対応いたします。',
      icon: 'ri-customer-service-line',
      stats: '満足度98%'
    }
  ];

  return (
    <section className="py-16 bg-blue-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            選ばれる理由
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            なぜ多くのお客様に選ばれ続けているのか
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {reasons.map((reason, index) => (
            <div key={reason.id} className="text-center">
              <div className="relative mb-6">
                <div className="w-20 h-20 flex items-center justify-center bg-blue-600 rounded-full text-white mx-auto mb-4">
                  <i className={`${reason.icon} text-3xl`}></i>
                </div>
                <div className="absolute -top-2 -right-2 bg-orange-500 text-white text-xs px-2 py-1 rounded-full font-semibold">
                  {String(index + 1).padStart(2, '0')}
                </div>
              </div>
              
              <h3 className="text-2xl font-bold text-gray-900 mb-3">
                {reason.title}
              </h3>
              
              <div className="bg-blue-600 text-white text-sm font-semibold py-1 px-3 rounded-full inline-block mb-4">
                {reason.stats}
              </div>
              
              <p className="text-gray-600 leading-relaxed">
                {reason.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
